// eslint-disable-next-line import-x/no-default-export
export default [
  'INIT',
  'REALTIME_QUESTION_ADDED',
  'REALTIME_DATA_UPDATE',
  'TOGGLE_SECONDARY_PANEL',
  'ON_UPLOAD_HANDOUTS_CLICK',
  ['ON_ASK_QUESTION', 'values', 'formSubmitPromise'],
  'REFETCH_LIVE_DATA',
  'POLL_ANSWERED',
  ['ON_UPLOAD_PROGRESS', 'fileName', 'percent'],
  'ON_SPEAKERS_INIT',
]
